import React, {Component} from 'react';
import {withRouteData} from 'react-static';
import styled from 'styled-components';

import EconomyChart from '../resources/images/economy-chart.png';

const EconomyStyle = styled.div`
	margin-bottom: 8rem;
	
	.chart {
		width: 100%;
	}
	
	.totalAmount {
		margin-bottom: 2.5rem;	
	
		h1 {
		    margin: 3rem 0 0;
	    }
	    
	    p {
		    color: rgba(255,255,255,0.3);
		}
	}
	
	.category {
	    line-height: 1.2;
	    
		.type {
			font-size: 2rem;
			font-weight: 500;
		}
		
		.amount {
			font-size: 3.125rem;
			font-weight: bold;
		}
		
		.text {
			font-size: 1.2rem;
		    color: #A2A2A2;
		    line-height: 1.5em;
		    margin-bottom: 0.5rem;
		    
		    &.marked {
		        color: #FFFFFF;
		        font-weight: bold;
		        margin-bottom: 0.1rem;
		    }
		}
		
		&-left {
		    margin-top: -3rem;
		}
		
		&-middle {
		    margin-top: 4rem;
		}
		
		&-right {
		    margin-top: -1rem;
		}
		
		@media screen and (max-width: 64em) {
			padding: 0;
			margin: 0;
			margin-top: 1rem;
	    }
	}
	
`;

class Economy extends Component {

	render() {

		return (
			<EconomyStyle>
				<div className="container">
					<div className="row text-center">
						<div className="columns small-10 small-centered">
							<h1 className="green">{ this.props.economy.economy }</h1>
							<p className="caption">{ this.props.economy.caption }</p>
						</div>
						<div className="columns small-12 small-centered totalAmount">
							<h1>{ this.props.economy.total }</h1>
							<p>{ this.props.economy.currency }</p>
						</div>
					</div>
					<div className="row text-center">
						<div className="columns small-12">
							<img src={EconomyChart} className="chart" alt="Expenses pie chart" />
						</div>
					</div>
					<div className="row">
						<div className="columns small-12 large-4">
							<div className="category category-left">
								<div className="type">OpEx</div>
								<div className="amount purple">3.6M</div>
								<div className="text marked">{ this.props.economy.opex.caption }</div>
								<div className="text">{ this.props.economy.opex.text1 }</div>
								<div className="text">{ this.props.economy.opex.text2 }</div>
								<div className="text">{ this.props.economy.opex.text3 }</div>
								<div className="text">{ this.props.economy.opex.text4 }</div>
							</div>
						</div>
						<div className="columns small-12 large-5">
							<div className="category category-middle">
								<div className="type">CapEx</div>
								<div className="amount green">3.5M</div>
								<div className="text">{ this.props.economy.capex.caption }</div>
								<div className="text marked">{ this.props.economy.capex.alpha }</div>
								<div className="text">{ this.props.economy.capex.alphaText }</div>
								<div className="text marked">{ this.props.economy.capex.beta }</div>
								<div className="text">{ this.props.economy.capex.betaText }</div>
								<div className="text marked">{ this.props.economy.capex.npi }</div>
								<div className="text">{ this.props.economy.capex.npiText }</div>
								<div className="text">{ this.props.economy.capex.text }</div>
							</div>
						</div>
						<div className="columns small-12 large-3">
							<div className="category category-right">
								<div className="type">{ this.props.economy.workingCapital.type }</div>
								<div className="amount cyan">7.9M</div>
								<div className="text marked">{ this.props.economy.workingCapital.caption }</div>
								<div className="text marked">{ this.props.economy.workingCapital.text1 }</div>
								<div className="text">{ this.props.economy.workingCapital.text2 }</div>
								<div className="text">{ this.props.economy.workingCapital.text3 }</div>
							</div>
						</div>
					</div>
				</div>
			</EconomyStyle>
		)
	}
}

export default withRouteData(Economy)


// WEBPACK FOOTER //
// /opt/build/repo/src/components/Economy.js